import { render, staticRenderFns } from "./editCompetencyModal.vue?vue&type=template&id=284f598f&"
import script from "./editCompetencyModal.vue?vue&type=script&lang=js&"
export * from "./editCompetencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports